document.addEventListener("DOMContentLoaded", () => {
    const links = document.querySelectorAll("a");
    links.forEach(link => {
        const href = link.getAttribute("href") || "";
        if (link.textContent.trim() === "" && !href.startsWith("#")) {
            if (href.includes("wa.me")) {
                link.textContent = " WhatsApp➚";
                link.target = "_blank";
                link.style.textDecoration = "underline";
            } else {
                link.textContent = href.replace("https://www.", "") + "➚";
                link.target = "_blank";
                link.style.textDecoration = "underline";
            }
        }
    });

    const vaccinesButton = document.querySelector("#vaccines_button");

    if (vaccinesButton) {
        const href = vaccinesButton.getAttribute("href") || "";
        fetch(href, {method: "get", mode: "no-cors"})
            .catch((error) => {
                vaccinesButton.parentElement.style.display = "none";
            });
    }
});
